import AlertTriangleIcon from '@crehana/compass.icons.outline/AlertTriangle';

import { useHomeTranslations } from '@/views/Home/hooks/use-home-translations';

export const GridWidgetsEmptyState: React.FC = () => {
  const { t } = useHomeTranslations();

  return (
    <div className="tw-col-span-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-8.8 tw-px-2 md:tw-px-9.6 tw-text-center tw-bg-neutral-light-100 tw-rounded-1 tw-shadow-01">
      <div className="tw-text-alert-500 tw-bg-alert-200 tw-rounded-full tw-p-1.2 tw-border-0.8 tw-border-solid tw-border-alert-100 tw-mb-1.2">
        <AlertTriangleIcon className="tw-fill-current tw-flex-none" size={28} />
      </div>
      <h4 className="tw-font-subtitle4 tw-font-semibold tw-mb-0.4">
        {t('GRID_WIDGETS_EMPTY_STATE_TITLE')}
      </h4>
      <p className="tw-font-body4 tw-text-neutral-light-700 dark:tw-text-neutral-dark-300">
        {t('GRID_WIDGETS_EMPTY_STATE_DESCRIPTION')}
      </p>
    </div>
  );
};
